(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsap-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionId = '{{ section.id }}';
    const heroSection = document.getElementById(`hero-${sectionId}`);
    
    if (!heroSection) return;

    window.addEventListener('load', function() {
      initHeroAnimations(sectionId);
    });

    function initHeroAnimations(sectionId) {
      const svgWrapper = document.querySelector(`#hero-svg-${sectionId}`);
      
      if (!svgWrapper) return;

      let elementToAnimate = svgWrapper.querySelector('svg');
      if (!elementToAnimate) {
        elementToAnimate = svgWrapper.querySelector('img');
      }

      if (!elementToAnimate) return;

      // 1. Force set the starting state (Opacity 0, Scale 0.8, Y +100px)
      gsap.set(elementToAnimate, {
        opacity: 0,
        scale: 0.8,
        y: 100
      });

      // 2. Animate to center (Opactiy 1, Scale 1, Y 0)
      const tl = gsap.timeline({
        defaults: {
          ease: 'power4.out'
        }
      });

      tl.to(elementToAnimate, {
        y: 0,          
        scale: 1,      
        opacity: 1,    
        duration: 1.8, 
        onComplete: function() {
          // Optional overshoot for a premium feel
          gsap.to(elementToAnimate, {
            y: -15,
            duration: 0.4,
            ease: 'power2.out',
            yoyo: true,
            repeat: 1,
            onComplete: function() {
              gsap.to(elementToAnimate, {
                y: 0,
                duration: 0.3,
                ease: 'power1.out'
              });
            }
          });
        }
      });

      // Pause marquee on hover (optional)
      const marqueeWrapper = document.querySelector(`#hero-text-${sectionId} .split-text-wrapper`);
      if (marqueeWrapper) {
        marqueeWrapper.addEventListener('mouseenter', function() {
          this.style.animationPlayState = 'paused';
        });
        marqueeWrapper.addEventListener('mouseleave', function() {
          this.style.animationPlayState = 'running';
        });
      }
    }

    // Re-initialize on section changes (for Theme Editor)
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.detail.sectionId === '{{ section.id }}') {
          setTimeout(() => {
            initHeroAnimations('{{ section.id }}');
          }, 100);
        }
      });

      document.addEventListener('shopify:section:reorder', function() {
        setTimeout(() => {
          initHeroAnimations('{{ section.id }}');
        }, 100);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
